module.exports = __webpack_public_path__ + "static/media/media_library2.171a5590.png";